// extracted by css-extract-rspack-plugin
var _1 = "hrTzAvMzr90yf8e1-xgNFQ--";
var _2 = "l1Fd8CC-32syO2D99ZbA1w-- hrTzAvMzr90yf8e1-xgNFQ--";
export { _1 as "background", _2 as "backgroundVisible" }
